import api from 'lib/trpcClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';
import { Api } from 'further-types/investment';

function useIncompleteInvestments(params: Api.GetIncompleteInvestmentsParams) {
  return api.incompleteInvestment.list.useQuery(params, {
    staleTime: QUERY_STALE_TIME_MS,
  });
}

export default useIncompleteInvestments;
